import {
    createStore,
    applyMiddleware,
    combineReducers
} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import {
    applicationContextReducer,
    guiReducer,
    userReducer,
    configurationReducer,
    mapReducer,
    quotationsReducer,
    quotationsFormReducer
} from '../features';

// root reducer
const rootReducer = combineReducers({
    applicationContext: applicationContextReducer,
    gui: guiReducer,
    user: userReducer,
    configuration: configurationReducer,
    map: mapReducer,
    quotations: quotationsReducer,
    quotationsForm: quotationsFormReducer
});

const middlewares = [];
 
if (process.env.NODE_ENV === 'development') {
    const { logger } = require('redux-logger');
    middlewares.push(logger);
}

// create store with redux saga
const appStore = createStore(
    rootReducer,
    composeWithDevTools(
        applyMiddleware(...middlewares)
    )
);

export default appStore;